import { get } from "lodash";
import env from "@beam-australia/react-env";

// =============== 图例 ================
import { ChartType } from "../types/global-type";

// 图例 item 宽度
export const LEGEND_ITEM_WIDTH = 108;
// 图例 group 高度
export const LEGEND_HEIGHT = 20;

// 图例翻页按钮 icon path
export const LEGEND_PAGE_ICON_PATH = {
  horizontal: [
    "path://M0.87269 4.24408C0.412228 4.64285 0.412228 5.35716 0.87269 5.75593L4.34517 8.76318C4.99281 9.32406 5.99982 8.86401 5.99982 8.00725L5.99982 1.99275C5.99982 1.136 4.99281 0.675948 4.34517 1.23682L0.87269 4.24408Z",
    "path://M5.12731 4.24408C5.58777 4.64285 5.58777 5.35716 5.12731 5.75593L1.65483 8.76318C1.00719 9.32406 0.000181331 8.86401 0.000181368 8.00725L0.000181631 1.99275C0.000181669 1.136 1.00719 0.675948 1.65483 1.23682L5.12731 4.24408Z",
  ],
};

// 图例翻页按钮 icon size
export const LEGEND_PAGE_ICON_SIZE = 10;
// =============== 图例 ================

// =============== grid ================
// 对于 直角坐标系 y轴 安全高度
export const Y_AXIS_MIN_HEIGHT = 60;
// =============== grid ================

// =============== x轴label ================
// x轴 label 倾斜角度
export const X_AXIS_LABEL_ROTATE = -30;
// font size
export const XAXIS_LABEL_FONTSIZE = 12;
// line height
export const XAXIS_LABEL_LINEHEIGHT = 12;
// itemTextWidth 指文字宽度 超出则省略号
export const XAXIS_LABEL_TEXT_ITEM = 108;

// x轴 label 长度 限制
export const X_AXIS_LABEL_MIN_WIDTH = 74;
export const X_AXIS_LABEL_MAX_WIDTH = 108;

// 对于 非类目轴 使用 splitNumber 控制显示的 label 数量 不同尺寸下 splitNumber 的值不同
export const X_AXIS_WIDTH_RATIO_LABEL_COUNT = 100;
// =============== x轴label ================

// =============== PIE ================
// 饼图 最多展示 DIMENSION 数量
// @ts-ignore
const e = env();
export const PIE_DIMENSION_LIMIT = Number.parseFloat(get(e, "REACT_APP__PIE_DIMENSION_LIMIT")) || 30;

// 饼图 label 宽度
export const PIE_LABEL_WIDTH = 60;

// 饼图 label 引导线 第2条 长度
export const PIE_LABEL_LINE_LENGTH2 = 12;

// 饼图 选中扇形偏移距离
export const PIE_SELECTED_OFFSET = 10;

// 环图 内圆半径相对外圆 比率
export const RING_PIE_SMALL_CIRCLE_RADIUS = 0.5;
// =============== PIE ================

// =============== 其他 ================
// series labe 在大数量情况下的可见性 小于此宽度 则强制不渲染 label
export const SERIES_AXIS_LABEL_MIN_WIDTH = 24;

// pie chart 当 canvas 最小边长小于该值 则强制不渲染 label
export const PIE_CHART_NOT_SHOW_LABEL = 1;
// =============== 其他 ================

// =============== chartType 相关 ================
export const IS_PIE_CHART: { [key in ChartType]: boolean } = {
  [ChartType.BASIC_BAR]: false,
  [ChartType.STACKED_COLUMN_BAR]: false,
  [ChartType.BASIC_LINE]: false,
  [ChartType.PIE_RING]: true,
  [ChartType.BASIC_PIE]: true,
};

export const IS_BAR_CHART: { [key in ChartType]: boolean } = {
  [ChartType.BASIC_BAR]: true,
  [ChartType.STACKED_COLUMN_BAR]: true,
  [ChartType.BASIC_LINE]: false,
  [ChartType.PIE_RING]: false,
  [ChartType.BASIC_PIE]: false,
};

export const IS_LINE_CHART: { [key in ChartType]: boolean } = {
  [ChartType.BASIC_BAR]: false,
  [ChartType.STACKED_COLUMN_BAR]: false,
  [ChartType.BASIC_LINE]: true,
  [ChartType.PIE_RING]: false,
  [ChartType.BASIC_PIE]: false,
};

export const IS_USE_AXIS_CHART: { [key in ChartType]: boolean } = {
  [ChartType.BASIC_BAR]: true,
  [ChartType.STACKED_COLUMN_BAR]: true,
  [ChartType.BASIC_LINE]: true,
  [ChartType.PIE_RING]: false,
  [ChartType.BASIC_PIE]: false,
};
// =============== chartType 相关 ================
